import { axiosPlacement } from "../services/AxiosInstance"

const API_URL = "/batches"

// Get all batches with optional pagination and search
export const getBatches = async (limit = 50000, page = 1, search = "", filters = {}) => {
  try {
    let url = `${API_URL}/full-data-list?limit=${limit}&page=${page}&search=${search}`;
    
    // Add additional filters to the URL
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        url += `&${key}=${encodeURIComponent(filters[key])}`;
      }
    });

    const response = await axiosPlacement.get(url)
    return response.data;
  } catch (error) {
    console.error("Error fetching batches", error)
    throw error
  }
}

// Create a new batch
export const createBatch = async (batchData) => {
  try {
    const response = await axiosPlacement.post(API_URL, batchData)
    return response.data
  } catch (error) {
    console.error("Error creating batch", {
      error: error.response?.data,
      requestData: batchData,
    })
    throw error
  }
}

// Update a batch by ID
export const updateBatch = async (batchId, batchData) => {
  try {
    const response = await axiosPlacement.put(`${API_URL}/${batchId}`, batchData)
    return response.data
  } catch (error) {
    console.error("Error updating batch", error)
    throw error
  }
}

// Delete a batch by ID
export const deleteBatch = async (batchId) => {
  try {
    const response = await axiosPlacement.delete(`${API_URL}/${batchId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting batch", error)
    throw error
  }
}

// Get a batch by ID

export const getBatchById = async (batchId) => {
  try {
    const response = await axiosPlacement.get(`${API_URL}/${batchId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching batch details", error)
    throw error
  }
}
